import { isTooManyRequestsError } from '@confluence/error-boundary/entry-points/isTooManyRequestsError.ts';
import { isUnauthenticatedError } from '@confluence/error-boundary/entry-points/isUnauthenticatedError.ts';

// these are expected policy / authz / throttling responses that customers on certain tenants
// (e.g. External User Security with step-up enforcement) will legitimately receive,
// and must NOT be counted as a view-page-labels experience failure.
const EXPECTED_LABELS_DATA_ERROR_MESSAGES = [
	'PermissionException',
	'not listed in the IP allowlist',
	'Step-up authentication is required',
	'rate limit exceeded',
];

type LabelsGraphQLErrorLike = {
	message?: string;
	extensions?: Record<string, unknown>;
};

type LabelsDataErrorLike = LabelsGraphQLErrorLike & {
	graphQLErrors?: readonly LabelsGraphQLErrorLike[];
};

const matchesKnownExpectedMessage = (errorLike: LabelsGraphQLErrorLike): boolean =>
	EXPECTED_LABELS_DATA_ERROR_MESSAGES.some((message) => errorLike.message?.includes(message));

export function isExpectedLabelsDataError(error: LabelsDataErrorLike | null | undefined): boolean {
	if (!error) {
		return false;
	}

	// Only suppress when EVERY returned GraphQL error is expected; a mixed
	// real + expected error should still surface and fail the experience.
	const isExpectedMessage = error.graphQLErrors?.length
		? error.graphQLErrors.every(matchesKnownExpectedMessage)
		: matchesKnownExpectedMessage(error);

	if (isExpectedMessage) {
		return true;
	}

	return isUnauthenticatedError(error as Error) || isTooManyRequestsError(error as Error);
}
